import {createContext, useContext} from "react";
import {TimelineFrameDataContext} from "../../../../TimelineFramePage";
import {
  getDepartmentabbreviation,
  getDepartmentDisplay,
  hasLinkValue,
  isPhoneVisit,
  isRemoteVisit
} from '../../../../../../utils/TimelineUtils';
import {isEmpty} from "lodash";
import {TYPE_FIMLAB, TYPE_VIDEO_CONFERENCE} from "../../../../../../definitions/TimelineItems";
import { linkkipalveluSelector } from '../../../../../../data/selector';
import { connect } from 'react-redux';


export const TimelineFrameContentLocationContext = createContext(null);
const TimelineFrameContentLocationWrapper = ({children, linkkipalvelu}) => {
    const { data } = useContext(TimelineFrameDataContext);

    if (!data.type || isEmpty(data.type)) {
        return null;
    }

    if (!data.department && !(data.type === TYPE_FIMLAB)) {
        return null;
    }

    if (isRemoteVisit(data) || isPhoneVisit(data)) {
        return null;
    }

    const attemptToGetLinkValue = (departmentAbbr) => {
      return linkkipalvelu.Toimipistetiedot &&
        linkkipalvelu.Toimipistetiedot[departmentAbbr];
    }

    let department = "";
    let link = "";
    const type = data.type;


    if (!(type === TYPE_FIMLAB)) {
        department = getDepartmentDisplay(data.department);
        const linkValue = attemptToGetLinkValue(getDepartmentabbreviation(data.department));

        if (hasLinkValue(linkValue)) {
          link = linkValue;
        }
    }

    return (
        <TimelineFrameContentLocationContext.Provider value={{department, type, link}}>
            {children}
        </TimelineFrameContentLocationContext.Provider>
    )
}


const mapStateToProps = (state) => {
  let linkkipalvelu = linkkipalveluSelector(state);
  return {
    linkkipalvelu
  }
}

export default connect(mapStateToProps)(TimelineFrameContentLocationWrapper);